export enum PresenceOfCoronaryStenosisEnum {
  NoStenosis = 'N',
  NonSignificantStenosis = 'L',
  SignificantStenosis = 'G',
  Unknown = 'U'
}

export enum HistoryOfCABGSurgeryEnum {
  Yes = 'Y',
  No = 'N',
  Unknown = 'U'
}
